import React from 'react';
import { useParams } from 'react-router-dom';
import { SignUpContainer } from '@/components/Auth/CreateAccount/SignUpContainer';

export const SignUp = () => {
    const { code } = useParams<{ code: string }>();
    return <SignUpContainer code={code!} />;
};
